import { LocalDate } from "@js-joda/core";

const dropOffLocationQueryKeys = {
  all: ["dropOffLocations"] as const,
  unavailableSlotsForDateIntervalByLocation: (
    locationId: string,
    startDate: LocalDate,
    endDate: LocalDate
  ) =>
    [
      ...dropOffLocationQueryKeys.all,
      "unavailableSlotsForWeekByLocation",
      locationId,
      { startDate, endDate },
    ] as const,
};

export default dropOffLocationQueryKeys;
